export default __webpack_public_path__ + "static/go-972eacb67cabf78fd8b5ad1f5376d0ff.svg";